import { bindDraftStoreToSession, createChunkRecovery, createDraftStore, createPendingSourceRegistry } from '@mbbe/config';
import { adminSession } from './session';

/** Mutation activity of the app's QueryClient(s); it outlives the screens that started the mutations. */
export const adminMutationActivity = createPendingSourceRegistry();

/**
 * Stale-deployment recovery for the admin surface (see @mbbe/config chunkRecovery).
 * Screens with unsaved or pending work register through `useUnsavedWork`; drafts are
 * stored only when the person keeps them for a reload and belong to the signed-in uid.
 */
export const adminRecovery = createChunkRecovery({ namespace: 'mbbe-admin', pendingSource: adminMutationActivity });
export const adminDrafts = createDraftStore({
  namespace: 'mbbe-admin',
  getUid: () => adminSession.current.uid,
});

// A draft never outlives the account that wrote it: sign-out or an account switch removes it.
bindDraftStoreToSession(adminSession, adminDrafts);
